import { createSlice } from "@reduxjs/toolkit";

export const counterSlice = createSlice({
  name: "venues",

  initialState: {
    "o2-institute-birmingham": {
      loc: { lat: 52.475702048072115, lng: -1.8870107836934336 },
      img: "o2-institute-birmingham.png",
      accent: "#0b1b54",
    },
    "o2-academy-birmingham": {
      loc: { lat: 52.47344826117485, lng: -1.8991337604139713 },
      img: "o2-academy-birmingham.png",
      accent: "#0b1b54",
    },
    "o2-academy-brixton": {
      loc: { lat: 51.46583419585972, lng: -0.11447927440287846 },
      img: "o2-academy-brixton.png",
      accent: "#0b1b54",
    },
    "castle-and-falcon": {
      loc: { lat: 52.46009462250921, lng: -1.8841029157273537 },
      img: "castle-and-falcon.png",
      accent: "#000000",
    },
    "sunflower-lounge": {
      loc: { lat: 52.47627112801558, lng: -1.896664036271151 },
      img: "sunflower-lounge.png",
      accent: "#ffffff",
    },
    "hare-and-hounds": {
      loc: { lat: 52.43472213070025, lng: -1.8926482492558248 },
      img: "hare-and-hounds.png",
      accent: "#ffffff",
    },
    "marble-factory": {
      loc: { lat: 51.449713490447145, lng: -2.575750364622065 },
      img: "marble-factory.webp",
      accent: "#000000",
    },
    "utilita-arena": {
      loc: { lat: 52.47981618552219, lng: -1.9146255762364643 },
      img: "utilita-arena.png",
      accent: "#ffffff",
    },
    "manc-academy": {
      loc: { lat: 53.463728915990195, lng: -2.2309849320335187 },
      img: "manc-academy.png",
      accent: "#133f46",
    },
    "ricoh-arena": {
      loc: { lat: 52.448446258725916, lng: -1.4971340400617454 },
      img: "ricoh-arena.png",
      accent: "#DD313A",
    },
    "rainbow-pub": {
      loc: { lat: 52.474335401138156, lng: -1.881085872526907 },
      img: "rainbow-pub.png",
      accent: "#ffffff",
    },
    "stadium-mk": {
      loc: { lat: 52.00982650026827, lng: -0.7329994832624364 },
      img: "stadium-mk.png",
      accent: "#000000",
    },
    barclaycard: {
      loc: { lat: 52.47981618552219, lng: -1.9146255762364643 },
      img: "barclaycard.png",
      accent: "#00aeef",
    },
    "civic-hall": {
      loc: { lat: 52.58683702145335, lng: -2.130049491579798 },
      img: "civic-hall.png",
      accent: "#5b5b5b",
    },
    "ally-pally": {
      loc: { lat: 51.59409726991988, lng: -0.12930978974580962 },
      img: "ally-pally.svg",
      accent: "#003DC6",
    },
    bullingdon: {
      loc: { lat: 51.747456745298216, lng: -1.2354083013785706 },
      img: "bullingdon.png",
      accent: "#ffffff",
    },
    "glee-club": {
      loc: { lat: 52.47450452229992, lng: -1.8962833948146036 },
      img: "glee-club.png",
      accent: "#c1091c",
    },
    "mama-roux": {
      loc: { lat: 52.47550678357233, lng: -1.8821838069277816 },
      img: "mama-roux.png",
      accent: "#911fe2",
    },
    sugarmill: {
      loc: { lat: 53.02516775840592, lng: -2.177914876224899 },
      img: "sugarmill.png",
      accent: "#ffffff",
    },
    "lg-arena": {
      loc: { lat: 52.448457830343315, lng: -1.7195487302002415 },
      img: "lg-arena.png",
      accent: "#000000",
    },
    genting: {
      loc: { lat: 52.448457830343315, lng: -1.7195487302002415 },
      img: "genting.webp",
      accent: "#ffffff",
    },
    kasbah: {
      loc: { lat: 52.413030410971096, lng: -1.5028661427173917 },
      img: "kasbah.png",
      accent: "#000000",
    },
    asylum: {
      loc: { lat: 52.488459874148944, lng: -1.9019656050726503 },
      img: "asylum.png",
      accent: "#000000",
    },
    koko: {
      loc: { lat: 51.53483111216012, lng: -0.13806418182073368 },
      img: "koko.svg",
      accent: "#000000",
    },
    aka: {
      loc: { lat: 52.06253750568911, lng: -1.3366516664640609 },
      img: "aka.jpeg",
      accent: "#fd3a67",
    },
    hmv: {
      loc: { lat: 52.475702048072115, lng: -1.8870107836934336 },
      img: "hmv.png",
      accent: "#000000",
    },
    'gorilla-manchester': {
      loc: { lat: 53.47435284224593, lng: -2.242334596012699 },
      img: "gorilla-manchester.jpg",
      accent: "#ffffff",
    },
    'canvas-manchester': {
      loc: { lat: 53.474230343325345, lng: -2.2390548306895655 },
      img: "canvas-manchester.jpg",
      accent: "#1b232a",
    },
    'deaf-institute': {
      loc: { lat: 53.470401052994475, lng: -2.2362569095791187 },
      img: "deaf-institute.png",
      accent: "#fc4935",
    },
    'o2-arena-london': {
      loc: { lat: 51.503113609724004, lng: 0.003393896091657579 },
      img: "o2-arena.png",
      accent: "#006",
    },
    'troxy-london': {
      loc: { lat: 51.51317505670182, lng: -0.04404711525403311 },
      img: "",
      accent: "#1c191a",
    }
    
    
  },

  reducers: {},
});

export default counterSlice.reducer;
